module.exports = __webpack_public_path__ + "static/img/publicService.788c52b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/publicService.png
// module id = eEIu
// module chunks = 44